import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: {
      '@id': item.href ? `https://www.penshuixitong.cn${item.href}` : undefined,
      name: item.label,
    },
  }));

  return (
    <>
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <span className="text-foreground-400 mx-1">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                )}
                {!isLast && item.href ? (
                  <Link
                    to={item.href}
                    className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="text-foreground-800 font-medium whitespace-nowrap">
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}